export default __webpack_public_path__ + "static/media/Lizzie.2bb04968.jpg";